<!--<pre>{{ config | json }}</pre>-->
<div style="display: block">
  <canvas #chart></canvas>
</div>
<!--<pre>{{ data | json }}</pre>-->
